import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, Box, Typography } from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";

import Loader from "../components/Loader/Loader";
import TipsSection from "../steps/Step4/molecules/TipsSection";
import FlightSummary from "../steps/Step4/organisms/FlightSummary";
import CardsForms from "../steps/Step4/organisms/CardsForms/CardsForms";
import { billingAddress } from "../constants/selectOptions";
import useStyles from "../steps/Step4/styles";
import Accreditation from "../components/Accreditation/Accreditation";
// import { getFormData, VIEW_FORM_BASE_URL } from "../api/api";
// import testOrderView from '../api/testOrderView5';

const FourthStepViewPage = () => {
  const [apiData, setApiData] = useState({});
  const { token, priceQuoteId } = useParams();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if(window.userData){
        setApiData(window.userData);
      }

      // setApiData(testOrderView);
    }

    return () => (mounted = false);
  }, []);

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: {},
    resolver: undefined,
    mode: "onChange",
  });

  const { register, setValue, formState } = methods;

  return (
    <FormProvider {...methods}>
      <form style={{ paddingBottom: "50px", height: "100%" }}>
        <Grid container style={{ height: "100%" }}>
          {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
            <FourthStepViewForm
              classes={classes}
              apiData={apiData}
              register={register}
              setValue={setValue}
              formState={formState}
            />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === "string" ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>
    </FormProvider>
  );
};

const FourthStepViewForm = ({
  classes,
  apiData,
  setValue,
  register,
  formState,
}) => {
  const selectedFlight = apiData?.priceQuotes.find(
    (item) => item.id == apiData?.result?.flight
  );

  if(!selectedFlight?.parts?.multiple){
    delete selectedFlight?.parts?.multiple
  }

  return (
    <>
      <Grid item xs={12} md={7} className={classes.mainForm}>
        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.headerText}
          >
            <Typography variant="h1" align="center">
              Payment information
            </Typography>
            <Typography variant="body1" align="center">
              All transactions are secure and encrypted
            </Typography>
          </Box>
        </Box>
        <Box className={classes.cardForm}>
          <CardsForms
            fields={apiData?.result?.cards}
            currentValues={apiData?.result?.cards}
            defaultCardValues={apiData?.result?.cards}
            addNewCard={() => {}}
            billingAddress={billingAddress}
            splitPaymentValue={apiData?.result?.splitPayment}
            remove={() => {}}
            setValue={() => {}}
            formType="view"
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={5}
        className={classes.secondaryForm}
        justify="flex-start"
        alignItems="center"
      >
        <TipsSection
          operatorInfo={apiData?.operatorInfo}
          register={register}
          defaultTips={apiData?.result?.tips}
          setValue={setValue}
          acceptTips={apiData?.result?.acceptTips}
        />
        <FlightSummary
          classes={classes}
          user_ip={apiData?.result?.user_ip}
          confirmTerms={apiData?.result?.confirmTerms}
          handleNext={() => {}}
          selectedFlight={selectedFlight}
          tipsValue={apiData?.result?.tips}
          acceptTipsValue={apiData?.result?.acceptTips}
          cards={apiData?.result?.cards}
          splitPaymentValue={apiData?.result?.splitPayment}
          manualSplitValue={apiData?.result?.manualSplit}
          register={register}
          setValue={setValue}
          travelCare={apiData?.result?.travelCare}
          airports={apiData?.airports}
          formState={formState}
          cardsAmmount={apiData?.result?.cardsAmmount}
          previewMode={true}
        />
        <Box width={1}>
          <Accreditation />
        </Box>
      </Grid>
    </>
  );
};

export default FourthStepViewPage;
